/* eslint-disable @nx/enforce-module-boundaries */
import { loan_application } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Icon } from '@axo/ui-core/components/Icon';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Heading, Text } from '@axo/ui-core/components/typography';
import { useFormContext, useWatch } from 'react-hook-form';
import { DebtProps } from './DebtDetails';
import styles from './debtDetails.module.scss';

type DebtDetailsHeaderProps = DebtProps & {
  type: loan_application.DebtType;
  source?: string;
};
export const DebtDetailsHeader = (props: DebtDetailsHeaderProps) => {
  const {
    type,
    index,
    debtNumber,
    editingDebtIndex,
    source,
    onEdit,
    onRemove,
  } = props;

  const { getFieldState } = useFormContext();

  const isEditing = editingDebtIndex === index;

  const { t } = useTranslation();

  const debts = useWatch({ name: 'LoanApplication/Debts' });

  const { invalid } = getFieldState(`LoanApplication/Debts.${index}`);

  return (
    <div className={styles.debtHeading} data-error={invalid}>
      {isEditing && (
        <Heading size="s">{t('Debt.label', { index: debtNumber })}</Heading>
      )}
      {!isEditing && <Heading size="xs">{t(`Debt.Type.${type}`)}</Heading>}

      <Stack direction="h" gap="2xs" align="end">
        {source && (
          <Text className={styles.badge} size="xs">
            {t('Debt.ESkatTag')}
          </Text>
        )}

        {index === 0 && invalid && debts?.length <= 1 && (
          <Text size="xs" className={styles.error}>
            {t('Debt.empty')}
          </Text>
        )}

        {!invalid && (
          <button type="button" onClick={onEdit}>
            <Icon name="pencil-simple-line" size="xs" />
          </button>
        )}

        {!source && (
          <button type="button" onClick={onRemove}>
            <Icon name="trash" size="xs" />
          </button>
        )}
      </Stack>
    </div>
  );
};
